import React, { useState , useEffect } from "react";
import { Link } from "react-router-dom";
import { AvatarPicture1 } from "component/Avatar";
import { SplideSlide, Splide } from "@splidejs/react-splide";
import api from "api";
import "./index.scss";
import _ from "lodash";
import update from "immutability-helper";


const RoleDiscovery = (props) => {
    const [isEOF, setIsEOF]             = useState(false);
    const [isLoading, setIsLoading]     = useState(true);
    const [roles, setRoles] = useState(false);
    const [listArgs, setListArgs]       = useState(_.assignIn({}, props.role_args, {
        posts_per_page : 20
        ,paged : 1
        ,sortby : 'RAND()'
        ,sort : ' '
        ,include_initiative : true
    }) || {});

    useEffect(() => {
        setIsLoading(true);
        api( props.endpoint ? props.endpoint :  '/Role', 'get', listArgs, props.token || '').then(response => {
            setIsLoading(false);

            if(response.roles.length < listArgs.posts_per_page)
            {
                setIsEOF(true);
            }

            if(roles !== false)
            {
                setRoles( roles.concat(response.roles));
            }
            else
            {
                setRoles(response.roles);
            }
            
        })
        .catch(() => {
            setIsLoading(false);
            setIsEOF(true);
        })

    }, [listArgs]);


    return (
        <div className="component-role-discovery">
            <Splide options={{
                autoWidth : true
                ,pagination : false
                ,arrows : false
            }} className="role-discovery-list">
                {
                    roles !== false && roles.map(role => ( 
                        <SplideSlide key={role.RoleID}>
                            <div className="role-discovery">
                                <div className="role-discovery-wrapper">
                                    <div className="role-information">
                                        <span className="block role-name">{role.RoleName}</span>
                                        <div className="leading-text text-xs role-desc" dangerouslySetInnerHTML={{ __html : role.RoleDesc}}/>

                                    </div>
                                    <div className="role-initiative" style={{backgroundImage : `url(${role.PosterImage})` }}>
                                        <div className="">
                                            <AvatarPicture1 user={role}/>
                                        </div>
                                        <div>
                                            <span className="block initiative-name leading-relaxed">{role.Title}</span>
                                            <span className="block initiator-name text-xs">{role.UserDisplayName}</span>
                                        </div>
                                    </div>
                                    <Link className="absolute inset" to={`/initiative/${role.Slug}`}></Link>
                                </div>
                            </div>
                        </SplideSlide>
                    ))
                }
                {
                    isLoading &&
                    <SplideSlide>
                        <div className="role-discovery">
                            <div className="role-discovery-wrapper">
                                <span className="skeleton"></span>
                            </div>
                        </div>
                    </SplideSlide>
                }
                {
                        !isEOF && !isLoading &&
                        <SplideSlide>
                            <div className="role-discovery">
                                <div className="card-load-more role-discovery-wrapper">
                                    <button className="load-more-card" onClick={e => {
                                        e.preventDefault();
                                        setListArgs(
                                            update(listArgs, {
                                                paged : {
                                                    $set : listArgs.paged ? listArgs.paged + 1 : 2
                                                }
                                            })
                                        );
                                    }}><span>Load More</span></button>
                                </div>
                            </div>
                        </SplideSlide>
                    }
                    {
                        roles !== false && roles.length == 0 &&
                        <SplideSlide>
                            <div className="role-discovery">
                                <div className="card-not-found role-discovery-wrapper">
                                    <span className="text-center bold block mt-4 mb-4">
                                        No Role Found
                                    </span>
                                </div>
                            </div>
                        </SplideSlide>
                    }
            </Splide>
        </div>
    )
}

export {RoleDiscovery}